<template>
    <a href="#" class="TableExpander" @click.prevent="toggle">
        <i :class="'fa fa-fw ' + icon"></i>
    </a>
</template>

<script>
    export default {
        data() {
            return {
                expanded: false,
                loading: false,
                loaded: false,
            }
        },

        props: {
            dataUrl: {
                type: String,
                required: true,
            },

            rank: {
                type: Number,
                required: true,
            },

            name: {
                type: String,
                required: true,
            }
        },

        mounted() {
            bus.$on('filters-updated', () => {
                this.expanded = false;
                this.loading = false;
                this.loaded = false;
            });
        },

        computed: {
            icon() {
                if (this.loading) {
                    return 'fa-circle-o-notch fa-spin';
                }

                return this.expanded ? 'fa-minus' : 'fa-plus';
            }
        },

        methods: {
            toggle() {
                if (this.loaded) {
                    bus.$emit('expand-table-row', this.rank, this.name);
                    return this.expanded = ! this.expanded;
                }

                this.loading = true;

                this.$http.post(this.dataUrl).then(response => {
                    this.loading = false;
                    this.loaded = true;
                    this.expanded = true;

                    bus.$emit('load-expanded-table-row', this.rank, this.name, response.data);
                });
            },
        }
    }
</script>
